import React, { useEffect, useState } from 'react';
import { separateBase64String } from 'js/library/utils/helpers';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

// STYLES
import { Button, CircularProgress, Grid, useMediaQuery } from '@mui/material';

//COMPONENTS
import { AlertColorSettings } from './AlertColorSettings';
import { AlertImageSettings } from './AlertImageSettings';
import { ContainerFormSegment } from 'js/components/Clubs/Segmentation/segmentStyles';
import { KeyWarningInformation } from './KeyWarningInformation';
import { PageStructure } from 'js/components/TriiboComponents/PageStructure/PageStructure';

// APIS
import { createAlerts } from 'js/library/utils/API/createAlerts';
import { getUserSegment } from 'js/library/utils/API/Segmentation/getUserSegment';
import { updateAlerts } from 'js/library/utils/API/updateAlerts';
import { uploadFiles } from 'js/library/utils/API/apiUploadFiles';
import { alertTypes } from 'js/library/utils/API/alertTypes';

export const CreateAndEditAlert = () => {
  const location = useLocation();
  const state = location.state;
  const alertSettings = state?.alertSettings && sanitizeEditInfo(state.alertSettings);
  const priorities =
    state?.priorities &&
    Object.values(
      state?.priorities.reduce((acc, item) => {
        if (!acc[item.type] || item.priority > acc[item.type].priority) {
          acc[item.type] = item;
        }
        return acc;
      }, {})
    );
  const imageHistory = alertSettings && alertSettings?.image;
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const partnerId = localStorage.getItem('partnerIdClube');
  const [alertData, setAlertData] = useState(
    alertSettings
      ? { ...alertSettings }
      : {
          alertTypeId: '',
          action: '',
          type: '',
          segments: [],

          image: '',

          buttonLabel: '',
          color: '',
          description: '',
          title: '',
          url: '',

          startDate: null,
          endDate: null,

          partnerId,
        }
  );
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [segments, setSegments] = useState([]);
  const [showButtonPopup, setShowButtonPopup] = useState(false);
  const [actionOptions, setActionsOptions] = useState({});

  useEffect(() => {
    const getAlertTypes = async () => {
      try {
        const response = await alertTypes();
        setActionsOptions(response);

        const matchedKey = Object.entries(response).find(
          ([_, value]) => value.type === alertData.action
        )?.[0]; // pega a chave correspondente ao action

        if (matchedKey) {
          setAlertData((prev) => ({
            ...prev,
            alertTypeId: matchedKey,
          }));
        }
      } catch (error) {
        console.error('Erro ao buscar tipos de alerta:', error);
      }
    };

    getAlertTypes();
  }, [alertData.action]);

  useEffect(() => {
    setLoadingPage(true);
    try {
      const data = { from: 0, size: 100, partnerId };

      (async function getSegmentationForUser() {
        const result = await getUserSegment(data);

        setSegments(result);
      })();
    } catch (error) {
      console.error('ERROR NA API DE SEGMENTOS ==> ', error);
    } finally {
      setLoadingPage(false);
    }
  }, [partnerId]);
  console.log(alertData);
  const changeDateForMilliSeconds = (type, date) => {
    if (!date) return null;

    let localDate;

    if (typeof date === 'string') {
      const [year, month, day] = date.split('-').map(Number);
      localDate = new Date(year, month - 1, day);
    } else {
      localDate = new Date(date);
    }

    switch (type) {
      case 'start':
        localDate.setHours(0, 0, 0, 0);
        break;
      case 'end':
        localDate.setHours(23, 59, 0, 0);
        break;
      default:
        break;
    }

    return localDate.getTime();
  };

  const createAndEditAlert = async () => {
    setLoadingCreate(true);
    try {
      let payload = alertData;
      // Definir prioridade baseada no type do payload
      const foundPriority = priorities?.find((item) => item.type === payload.type);
      payload.priority = foundPriority?.priority !== undefined ? foundPriority.priority + 1 : 0;

      payload.startDate = changeDateForMilliSeconds('start', payload.startDate);
      payload.endDate = changeDateForMilliSeconds('end', payload.endDate);
      console.log(payload.startDate, payload.endDate);
      if (
        !payload.action ||
        !payload.type ||
        !payload.startDate ||
        !payload.endDate ||
        !payload.description ||
        !payload.color
      ) {
        return toast.warning('Todos os campos são obrigatórios.');
      }

      if (payload.startDate >= payload.endDate) {
        return toast.warning('A data de fim do alerta deve ser posterior a data de início.');
      }

      if (payload.type === 'popup') {
        if (!payload.image) {
          return toast.warning('É necessário enviar uma imagem para o tipo pop-up.');
        } else if (!payload.title) {
          return toast.warning('O título para o pop-up deve ser preenchido.');
        }

        if (showButtonPopup) {
          if (!payload.buttonLabel) {
            return toast.warning('É necessário preencher um texto para o botão.');
          } else if (!payload.url) {
            return toast.warning('É necessário preencher a URL.');
          }
        }
      }

      if (payload.type === 'popup' && payload.image !== imageHistory) {
        const image = separateBase64String(payload.image);
        const path = await uploadFiles(
          '/path',
          {
            mimeType: image.mimeType,
            fileName: `popupImage-${partnerId}`,
            buffer: image.buffer,
          },
          true
        );

        payload.image = path;
      }
      const SanitizePayload = removeEmptyStrings(payload);
      delete SanitizePayload.updateDate;

      alertSettings ? await updateAlerts(SanitizePayload) : await createAlerts(SanitizePayload);

      toast.success('Alerta criado com sucesso.');
      window.history.back();
    } catch (error) {
      toast.error('Algo não funcionou corretamente, tente novamente mais tarde!');
      console.error('ERROR API createAlerts ==> ', error);
    } finally {
      setLoadingCreate(false);
    }
  };

  const handleColor = (color) => {
    setAlertData((prevAlertData) => ({ ...prevAlertData, color: color }));
  };

  const handleInputs = (value, label) => {
    switch (label) {
      // TRATA SELECTS
      case 'Tipo':
        setAlertData((prevAlertData) => ({ ...prevAlertData, type: value }));
        break;
      case 'Segmentos':
        setAlertData((prevAlertData) => ({ ...prevAlertData, segments: value }));
        break;
      case 'Ação':
        setAlertData((prevAlertData) => ({ ...prevAlertData, action: value }));
        break;

      // TRATA DATAS
      case 'Data do início':
        setAlertData((prevAlertData) => ({ ...prevAlertData, startDate: value }));
        break;
      case 'Data do fim':
        setAlertData((prevAlertData) => ({ ...prevAlertData, endDate: value }));
        break;

      // TRATA INPUTS
      case 'Título':
        setAlertData((prevAlertData) => ({ ...prevAlertData, title: value }));
        break;
      case 'Descrição':
        setAlertData((prevAlertData) => ({ ...prevAlertData, description: value }));
        break;

      case 'Texto do botão':
        setAlertData((prevAlertData) => ({ ...prevAlertData, buttonLabel: value }));
        break;

      case 'Url':
        setAlertData((prevAlertData) => ({ ...prevAlertData, url: value }));
        break;

      case 'URL do botão':
        setAlertData((prevAlertData) => ({ ...prevAlertData, url: value }));
        break;
      default:
        break;
    }
  };

  const removeEmptyStrings = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== ''));
  };

  function sanitizeEditInfo(info) {
    // Garantir que startDate e endDate sejam números (convertendo para número usando "+" para garantir que sejam números)
    info.startDate = +info.startDate;
    info.endDate = +info.endDate;

    // Verificar se 'segments' é uma string. Se for, transforma em um array, senão deixa como está.
    if (typeof info.segments === 'string') {
      info.segments = [info.segments];
    }

    // Retornar o objeto 'info' já com os valores tratados
    return info;
  }

  return (
    <PageStructure title={alertSettings ? 'Editar Alerta' : 'Criar alerta'}>
      {loadingPage ? (
        <CircularProgress size={50} thickness={5} />
      ) : (
        <Grid container spacing={3} alignItems={'start'}>
          <Grid item md={alertData.type === '' ? 12 : 6} xs={12}>
            <KeyWarningInformation
              actionOptions={actionOptions}
              alertData={alertData}
              handleInputs={handleInputs}
              segments={segments}
              showButtonPopup={showButtonPopup}
              setShowButtonPopup={setShowButtonPopup}
              alertSettings={alertSettings}
            />
            {alertData.type !== '' && isMdUp && (
              <ContainerFormSegment
                style={{
                  width: alertData.type === '' ? '50%' : '100%',
                  marginTop: '1rem',
                  minHeight: '1rem',
                }}
              >
                <Button onClick={createAndEditAlert} variant="contained">
                  {loadingCreate ? (
                    <CircularProgress size={25} thickness={5} sx={{ color: '#fff' }} />
                  ) : alertSettings ? (
                    'Editar Alerta'
                  ) : (
                    'Criar alerta'
                  )}
                </Button>
              </ContainerFormSegment>
            )}
          </Grid>

          {alertData.type !== '' && (
            <Grid item md={6} xs={12}>
              <AlertColorSettings
                alertData={alertData}
                handleColor={handleColor}
                handleInputs={handleInputs}
                showButtonPopup={showButtonPopup}
              />
              <AlertImageSettings alertData={alertData} setAlertData={setAlertData} />
            </Grid>
          )}

          {(alertData.type === '' || (alertData.type !== '' && !isMdUp)) && (
            <Grid item md={alertData.type === '' ? 12 : 6} xs={12}>
              <ContainerFormSegment
                style={{
                  width: alertData.type === '' && isMdUp ? '50%' : '100%',
                  margin: '0 auto',
                  minHeight: '1rem',
                }}
              >
                <Button onClick={createAndEditAlert} variant="contained">
                  {loadingCreate ? (
                    <CircularProgress size={25} thickness={5} sx={{ color: '#fff' }} />
                  ) : alertSettings ? (
                    'Editar Alerta'
                  ) : (
                    'Criar alerta'
                  )}
                </Button>
              </ContainerFormSegment>
            </Grid>
          )}
        </Grid>
      )}
    </PageStructure>
  );
};
